import type {
  TripWritable,
  TripsBulkCreateWritable,
} from '@bambi/api-client/schemas';

import type { AddTripFormValues } from '../FormValues';
import { buildNewTripPayload } from './adaptFormValuesHelpers';

export function adaptFormValuesToTripsBulkCreate(
  formValues: AddTripFormValues
): TripsBulkCreateWritable {
  return {
    trips: formValues.trips.map((trip): TripWritable =>
      buildNewTripPayload(trip, formValues)
    ),
  };
}
